import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  id: "kt-user-menu",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-50px symbol-circle me-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "media/avatars/150-1.jpg"
  })
], -1)
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_7 = ["title"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_9 = { class: "menu-item px-5" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Profile ")
const _hoisted_11 = { class: "menu-item px-5" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "menu-text" }, "Dashboard", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "menu-badge" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-danger badge-circle fw-bolder fs-7" }, "3")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", {
              "data-bs-toggle": "tooltip",
              "data-bs-placement": "top",
              title: _ctx.user,
              style: {"cursor":"default"}
            }, _toDisplayString(_ctx.userName.length > 12
                  ? _ctx.userName.substring(0, 12) + "..."
                  : _ctx.userName), 9, _hoisted_7)
          ])
        ])
      ])
    ]),
    _createElementVNode("span", {
      "data-bs-toggle": "tooltip",
      "data-bs-placement": "top",
      title: "System Admin",
      style: {"cursor":"default"},
      class: _normalizeClass(_ctx.classRole)
    }, _toDisplayString(_ctx.user["role"] === "SUPER_ADMIN"
          ? "SUPER_ADMIN"
          : _ctx.user["role"] === "ADMIN"
          ? "ADMIN"
          : _ctx.user["role"] === "MANAGER"
          ? "MANAGER"
          : _ctx.user["role"] === "BRANCH MANAGER"
          ? "BRANCH"
          : _ctx.user["role"] === "STAFF"
          ? "STAFF"
          : ""), 3),
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.classRole)
    }, _toDisplayString(_ctx.companyData["company_code"]) + " " + _toDisplayString(_ctx.companyData["company_name"]), 3),
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.classRole)
    }, _toDisplayString(_ctx.branchData["code"]) + " " + _toDisplayString(_ctx.branchData["name"]), 3),
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.classRole)
    }, _toDisplayString(_ctx.warehouseData["warehouse_code"]) + " " + _toDisplayString(_ctx.warehouseData["warehouse_short_name"]) + " " + _toDisplayString(_ctx.warehouseData["warehouse_full_name"]), 3),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_router_link, {
        to: "/setting/user-profile",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_router_link, {
        to: "/dashboard",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _hoisted_12,
          _hoisted_13
        ]),
        _: 1
      })
    ]),
    _hoisted_14,
    _createElementVNode("div", {
      class: "menu-item px-5",
      onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.enterSignOut())),
      onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.leaveSignOut()))
    }, [
      _createElementVNode("a", {
        class: "menu-link px-5",
        style: _normalizeStyle(_ctx.cssSignOut),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut()))
      }, " Sign Out ", 4)
    ], 32)
  ]))
}